import { render, staticRenderFns } from "./SalonDetail.vue?vue&type=template&id=50098c60"
import script from "./SalonDetail.vue?vue&type=script&lang=ts"
export * from "./SalonDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports